import { createSelector, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const initialAdminInfo = {
    readOnly: false
};

export const adminInfoSlice = createSlice({
    name: "adminInfo",
    initialState: initialAdminInfo,
    reducers: {
        setReadOnly: (state, action): void => {
            state.readOnly = action.payload;
        }
    }
});

export const { setReadOnly } = adminInfoSlice.actions;

export const readOnlySelector = createSelector(
    (state: RootState): boolean => state.adminInfo.readOnly,
    (readOnly: boolean) => readOnly
);